import axios from 'axios';
import { browserHistory } from 'react-router';
import { logout } from '../actions';
import { store } from '../Root';

// let URL = 'http://35.164.227.24:4000/api';
let URL = 'https://beta.iesdev.com/api';
// let URL = 'http://localhost:4000/api';
const instance = axios.create({ baseURL: URL });
const unauthedInstance = axios.create({ baseURL: URL });

if (process.env.NODE_ENV === 'production') {
  URL = 'https://beta.iesdev.com/api';
}

instance.interceptors.request.use((config) => {
  console.log(`\n(${config.method.toUpperCase()}) ${config.url} ${config.params ? JSON.stringify(config.params) : JSON.stringify(config.data)}`);
  return config;
}, (error) => {
  console.log(error)
  return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  if (error.response.status === 403 || error.response.status === 401) {
    store.dispatch(logout())
    browserHistory.push('/login');
  }
  console.log("Sigh")
  return Promise.reject(error);
});

class BlitzAPI {
  setToken(token) {
    console.log('Set token');
    instance.defaults.headers.common['Authorization'] = `Token ${token}`;
  }
  post(params) {
    return instance.post('/example', params);
  }
  put(params) {
    return instance.put('/example', params);
  }
  getUser(userId) {
    return instance.get(`/users/${userId}`);
  }
  getUsers(params) {
    return instance.get('/users', { params });
  }
  postUser(params) {
    return instance.post('/users', params);
  }
  patchUser(params) {
    return instance.patch('/users', params);
  }
  patchAnyUser(userId, params) {
    return instance.patch(`/users/${userId}`, params);
  }
  postLogin(params) {
    return unauthedInstance.post('/users/login', params);
  }

  getEntry(entryId) {
    return instance.get(`/entries/${entryId}`);
  }

  deleteEntry(entryId) {
    return instance.delete(`/entries/${entryId}`);
  }

  parseEntryFromUrl(params) {
    return instance.get('/entries/preview', { params });
  }

  getEntries(params = {}) {
    return instance.get('/entries/', { params });
  }

  postEntry(params) {
    return instance.post('/entries/', params);
  }


  patchEntry(entryId, params) {
    return instance.patch(`/entries/${entryId}`, params);
  }

  postEntryImage(params) {
    return instance.post('/entries/image/', params);
  }

  getSources() {
    return instance.get('/sources/');
  }

  getSource(sourceId) {
    return instance.get(`/sources/${sourceId}`);
  }

  postSource(params) {
    return instance.post('/sources/', params);
  }

  patchSource(sourceId, params) {
    return instance.patch(`/sources/${sourceId}`, params);
  }

  deleteSource(sourceId) {
    return instance.delete(`/sources/${sourceId}`);
  }

  sendPushNotification(params) {
    return instance.post('/notifications/', params);
  }

  getChatRooms(params = {}) {
    return instance.get('/chatchannels', { params });
  }

  getChatRoom(chatRoomId) {
    return instance.get(`/chatchannels/${chatRoomId}`);
  }

  // Tags

  getTags(params) {
    return instance.get('/tags', { params });
  }

  getTag(tagId) {
    return instance.get(`/tags/${tagId}`);
  }

  postTag(params) {
    return instance.post('/tags', params);
  }

  patchTag(tagId, params) {
    return instance.patch(`/tags/${tagId}`, params);
  }

  deleteTag(tagId) {
    return instance.delete(`/tags/${tagId}`);
  }

  postEntryTag(params) {
    return instance.post('/entrytags', params);
  }

  deleteEntryTag(params) {
    return instance.delete('/entrytags', { params });
  }

  // Beta Users

  postCheckActivated(params) {
    return instance.post('/beta/activate', params);
  }

  postAddBetaUser(params) {
    return instance.post('/beta/add', params);
  }

  getTotalBetaUsers() {
    return instance.get('/beta/total');
  }

  getStatsOverview() {
    return instance.get('/tracking/app/overall');
  }

  getStatsFilterable(params) {
    return instance.get('/tracking/app/filterable_stats', { params });
  }

  getStatsUsers(params) {
    return instance.get('/tracking/app/users/', { params });
  }

  // Chatrooms

  postChatRoom(params) {
    return instance.post('/chatchannels', params);
  }

  reparseChatRoom(chatRoomId) {
    return instance.post(`/chatchannels/${chatRoomId}/reparse`);
  }

  patchChatRoom(channelId, params = {}) {
    return instance.patch(`/chatchannels/${channelId}`, params);
  }

  deleteChatRoom(channelId) {
    return instance.delete(`/chatchannels/${channelId}`);
  }

  getTwitterEmbed(params) {
    return instance.get('/tweet_embed', { params });
  }
  getToast(params) {
    return instance.get(`/beta/toast`, { params });
  }
  getSurvey(params) {
    return instance.get(`/beta/survey`, { params });
  }
  postToast(params) {
    return instance.post(`/beta/toast`, params);
  }
  postSurvey(params) {
    return instance.post(`/beta/survey`, params);
  }
}
export default new BlitzAPI();



// WEBPACK FOOTER //
// ./src/api/BlitzAPI.js